<template>
  <v-layout row wrap align-center v-on:keyup.enter="queryGeneralCourseInfo">
    <v-flex md2>
      <v-select
        :label="labels.ge_type"
        v-model="select_dimension"
        :items="dimensions"
        :item-text="select"
        item-value="DimNo"
      ></v-select>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.course_title"
        v-model="course_name"
      ></v-text-field>
    </v-flex>
    <v-flex md2>
      <v-text-field
        :label="labels.instructor"
        v-model="course_teacher"
      ></v-text-field>
    </v-flex>
    <v-flex md1 nowrap align-self-center>
      <v-checkbox
        :label="labels.famous_expert_course"
        v-model="select_course_notes"
        value="nn"
      ></v-checkbox>
    </v-flex>
    <v-flex md1 align-self-center>
      <v-checkbox :label="labels.excl_ntu" v-model="only_ntust"></v-checkbox>
    </v-flex>
    <v-flex md2 align-self-center>
      <v-tooltip top>
      <template v-slot:activator="{ on }">
          <div v-on="on">
              <v-btn flat
                     href="https://dss20.ntust.edu.tw/edua/courlist/qry_coursebook.aspx?fid=2&sid=1&tid=3">
                  <v-icon left>link</v-icon>
                  {{ labels.ge_class_timetable }}
              </v-btn>
          </div>
      </template>
      <span> {{ labels.download_info}}</span>
      </v-tooltip>
    </v-flex>
    <v-flex md1>
      <v-btn round :disabled="btn_state" v-on:click="queryGeneralCourseInfo()">
        <v-icon>search</v-icon>
        {{ labels.search }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import languages from "../../languages/TabGeneral.json";

export default {
  data: () => ({
    labels: {
      ge_type: "",
      course_title: "",
      instructor: "",
      famous_expert_course: "",
      excl_ntu: "",
      ge_class_timetable: "",
      search: "",
    },
    select: "",
    course_name: "",
    course_teacher: "",
    select_course_notes: [],
    only_ntust: "",
  }),
  computed: {
    btn_state() {
      return this.$store.state.btn_state;
    },
    dimensions() {
      return this.$store.state.dimensions;
    },
    select_dimension: {
      get() {
        return this.$store.state.select_dimension;
      },
      set(value) {
        this.$store.commit("setSelectDimension", value);
      },
    },
    select_language() {
      return this.$store.state.select_language;
    },
  },
  watch: {
    select_language(value) {
      this.setLanguage(value);
    },
  },
  created() {
    this.setLanguage(this.$store.state.select_language);
    this.$store.dispatch("getAllDimensions");
  },
  methods: {
    queryGeneralCourseInfo: function () {
      var query_params = {
        Semester: this.$store.state.select_semester,
        CourseNo: "",
        CourseName: this.course_name,
        CourseTeacher: this.course_teacher,
        Dimension: this.$store.state.select_dimension,
        CourseNotes: this.select_course_notes,
        ForeignLanguage: 0,
        OnlyGeneral: 1,
        OnleyNTUST: this.only_ntust * 1,
        OnlyMaster: 0,
        Language: this.select_language.lang,
      };
      this.$store.dispatch("queryCourseInfo", query_params);
    },
    setLanguage: function (select_language) {
      this.labels.ge_type = languages.ge_type[select_language.lang];
      this.labels.course_title = languages.course_title[select_language.lang];
      this.labels.instructor = languages.instructor[select_language.lang];
      this.labels.famous_expert_course =
        languages.famous_expert_course[select_language.lang];
      this.labels.excl_ntu = languages.excl_ntu[select_language.lang];
      this.labels.ge_class_timetable =
        languages.ge_class_timetable[select_language.lang];
      this.labels.search = languages.search[select_language.lang];
      this.select = languages.select[select_language.lang];
      this.labels.download_info =
        languages.download_info[select_language.lang];
    },
  },
};
</script>
